import React from 'react';
import PropTypes from 'prop-types';

import * as smallDrawerTypes from 'types/smallDrawer';
import Information from 'components/Feed/Drawers/Informations/container';
import Members from 'components/Feed/Drawers/Members/container';
import Gallery from 'components/Feed/Drawers/Gallery/container';
import CatchError from 'components/CatchError';

const SmallDrawerManager = ({ type, _feed }) => {
    let Drawer = null;
    let content = null;
    let extraProps = {};

    switch (type) {
        case smallDrawerTypes.FEED_DRAWER_INFORMATIONS:
            Drawer = Information;
            break;
        case smallDrawerTypes.FEED_DRAWER_MEMBERS:
            Drawer = Members;
            break;
        case smallDrawerTypes.FEED_DRAWER_GALLERY:
            Drawer = Gallery;
            break;
        default:
            break;
    }
    if (_feed) extraProps = { _feed };
    if (Drawer) content = <Drawer {...extraProps} />;

    if (content) return <CatchError>{content}</CatchError>;
    return null;
};

SmallDrawerManager.propTypes = {
    type: PropTypes.string,
    _feed: PropTypes.string
};

export default SmallDrawerManager;
